// extracted by mini-css-extract-plugin
export default {"titlePage":"application_titlePage__0GqNi"};